var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "5 5 30 30", height: "36", width: "36" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "a" },
        React.createElement("path", { d: "M15 30h132.16v31.126H15z" })
      )
    ),
    React.createElement(
      "g",
      { clipPath: "url(#a)", transform: "matrix(1.33333 0 0 -1.33333 -20 81.5)" },
      React.createElement("path", { d: "M39.785 39.847c-.672 0-.961-.504-.937-1.201-.024-1.008-1.37-1.897-2.785-.84l-2.378 1.825c3.722.36 6.34 3.626 6.34 7.9 0 4.444-2.954 7.71-7.085 7.71-4.106 0-7.084-3.314-7.084-7.71 0-2.57 1.008-4.85 2.665-6.29-1.032-.385-1.85-1.25-1.85-2.235 0-.6.434-1.055.89-1.08.504 0 .936.432.936 1.008 0 1.033 1.44 1.537 2.858.6l3.219-2.233c1.152-.72 2.257-1.128 3.146-1.152 1.633-.024 3.002 1.152 3.026 2.64 0 .626-.313 1.035-.961 1.058m-11.6 8.406c0 4.947 2.018 6.028 4.755 6.028 2.258 0 4.78-2.906 4.78-7.47 0-4.875-1.97-6.123-4.828-6.123-.336 0-.672.072-1.008.168-.192.12-.385.217-.577.288-1.705.96-3.122 3.458-3.122 7.109", fill: "#fff" }),
      React.createElement("path", { d: "M21.824 40.015c.672 0 .96-.504.937-1.2.024-1.01 1.369-1.898 2.785-.841l2.378 1.825c-3.722.36-6.34 3.626-6.34 7.902 0 4.442 2.954 7.709 7.085 7.709 4.106 0 7.084-3.314 7.084-7.71 0-2.57-1.008-4.851-2.665-6.291 1.032-.384 1.849-1.25 1.849-2.235 0-.6-.433-1.055-.89-1.08-.503 0-.935.433-.935 1.008 0 1.033-1.441 1.537-2.858.6l-3.22-2.233c-1.151-.72-2.256-1.128-3.145-1.151-1.633-.025-3.002 1.15-3.026 2.64 0 .625.313 1.034.96 1.057m11.6 8.406c0 4.948-2.017 6.029-4.754 6.029-2.258 0-4.78-2.907-4.78-7.47 0-4.876 1.97-6.123 4.828-6.123.336 0 .672.07 1.008.168.192.119.385.216.577.287 1.705.962 3.122 3.458 3.122 7.109", fill: "#fff" })
    )
  );
});